(function () {
  var DATA = JSON.parse(document.getElementById('lc-data').textContent);
  var SORTED_DATA = DATA.slice().sort(function (a, b) { return a.title.localeCompare(b.title); });
  var ALL_FEATURES = [
    { key: "Leakproof", label: "Leakproof" },
    { key: "Machine washable", label: "Machine washable" },
    { key: "Adjustable", label: "Adjustable" },
    { key: "Overnight", label: "Overnight" },
    { key: "PFAs Free", label: "PFAs Free" },
    { key: "OEKO-TEX certified", label: "Made from OEKO-TEX certified materials" },
    { key: "Ultra thin leakproof design", label: "Ultra thin leakproof design" }
  ];
  var PFAS_LINK = window.lcPfasLink || '';

  var chosenDefaults = (window.lcDefaultIds || []).filter(Boolean).map(String);
  var selected = chosenDefaults.length ? chosenDefaults : DATA.slice(0, 2).map(function (p) { return String(p.id); });
  var swatchOverride = {};

  function byId(id) {
    return DATA.filter(function (p) { return String(p.id) === String(id); })[0];
  }

  function currentSwatchIndex(col, p) {
    var swatches = p.swatches || [];
    if (swatchOverride[col] != null && swatches[swatchOverride[col]]) return swatchOverride[col];
    for (var i = 0; i < swatches.length; i++) {
      if (swatches[i].selected) return i;
    }
    return 0;
  }

  function renderBoard() {
    var board = document.getElementById('lc-board');
    board.innerHTML = selected.map(function (id, col) {
      var p = byId(id);
      if (!p) return '';
      var options = SORTED_DATA.map(function (prod) {
        return '<option value="' + prod.id + '"' + (String(prod.id) === String(id) ? ' selected' : '') + '>' + prod.title + '</option>';
      }).join('');

      var swatchList = p.swatches || [];
      var activeIdx = currentSwatchIndex(col, p);
      var activeSwatch = swatchList[activeIdx];
      var displayImage = (activeSwatch && activeSwatch.image) || p.image;

      // Price now follows the selected colour swatch when that swatch carries
      // its own variant pricing; falls back to the product-level price
      // (fixes "colour swatches work but price doesn't change")
      var priceSource = (activeSwatch && activeSwatch.price) ? activeSwatch : p;
      var priceHtml = priceSource.on_sale
        ? '<span class="lc-price-sale">' + priceSource.price + '</span> <span class="lc-price-compare">' + priceSource.compare_at_price + '</span>'
        : priceSource.price;

      var swatches = swatchList.map(function (s, i) {
        return '<button type="button" class="lc-swatch' + (i === activeIdx ? ' lc-swatch--selected' : '') +
          '" style="background:' + s.color + ';" data-col="' + col + '" data-swatch="' + i + '" aria-label="Swatch ' + (i + 1) + '"></button>';
      }).join('');
      var swatchesHtml = swatches ? '<div class="lc-swatches">' + swatches + '</div>' : '';

      return (
        '<div>' +
        '<div class="lc-select-wrap">' +
        '<span class="lc-select-label">Choose a style</span>' +
        '<select class="lc-select" data-col="' + col + '">' + options + '</select>' +
        '</div>' +
        '<img class="lc-card-image" src="' + displayImage + '" alt="' + p.title + '">' +
        swatchesHtml +
        '<div class="lc-price">' + priceHtml + '</div>' +
        '<a class="lc-shop-btn" href="' + p.url + '">SHOP NOW</a>' +
        '</div>'
      );
    }).join('');

    Array.prototype.forEach.call(board.querySelectorAll('.lc-select'), function (sel) {
      sel.addEventListener('change', function (e) {
        var col = parseInt(e.target.getAttribute('data-col'), 10);
        delete swatchOverride[col];
        selected[col] = e.target.value;
        renderAll();
      });
    });

    Array.prototype.forEach.call(board.querySelectorAll('.lc-swatch'), function (btn) {
      btn.addEventListener('click', function (e) {
        var col = parseInt(e.target.getAttribute('data-col'), 10);
        var idx = parseInt(e.target.getAttribute('data-swatch'), 10);
        swatchOverride[col] = idx;
        renderBoard();
      });
    });
  }

  function renderDetails() {
    var items = selected.map(function (id) { return byId(id); });

    // Each field is emitted as one row pair (col1 div, col2 div) in sequence.
    // Because .lc-grid3 is a real CSS grid, each row auto-sizes to the taller
    // of the two columns, so "Best for" (and everything else) always lines
    // up across columns even when the content above it wraps differently
    // (fixes cross-column drift reported 7/22).
    function row(renderField) {
      return items.map(function (p) {
        if (!p) return '<div></div>';
        return '<div>' + renderField(p) + '</div>';
      }).join('');
    }

    var html = '';
    html += row(function () { return '<div class="lc-label-sm">Collection</div>'; });
    html += row(function (p) { return '<div class="lc-detail-system">' + (p.comparison_system_label || '') + '</div>'; });
    html += row(function () { return '<div class="lc-label-sm">Absorbency</div>'; });
    html += row(function (p) {
      var dropsImg = p.drops_image ? '<img class="lc-drops" src="' + p.drops_image + '" alt="absorbency rating">' : '';
      var tamponsHtml = p.tampons
        ? '<div class="lc-detail-tampons"><span class="lc-bignum">' + p.tampons + '</span><span class="lc-unit">tampons</span></div>'
        : '';
      return tamponsHtml + dropsImg;
    });
    html += row(function (p) { return '<div class="lc-detail-coverage">' + (p.comparison_coverage_summary || '') + '</div>'; });
    html += row(function () { return '<div class="lc-label-sm">Best for</div>'; });
    html += row(function (p) {
      var bestFor = (p.best_for || '').split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
      return bestFor.map(function (b) { return '<div class="lc-bestfor-item">' + b + '</div>'; }).join('');
    });
    document.getElementById('lc-details').innerHTML = html;
  }

  function renderPerformance() {
    document.getElementById('lc-performance').innerHTML = selected.map(function (id) {
      var p = byId(id);
      if (!p) return '';
      var features = p.comparison_features || {};
      var rows = ALL_FEATURES.map(function (f) {
        var has = !!features[f.key];
        var label = f.label;
        // PFAs-Free asterisk + link to info page (Lux/Brian 7/22)
        if (f.key === 'PFAs Free') {
          label = PFAS_LINK
            ? 'PFAs Free<a class="lc-note-link" href="' + PFAS_LINK + '">*</a>'
            : 'PFAs Free*';
        }
        return '<li class="' + (has ? '' : 'no') + '"><span class="' + (has ? 'lc-tick' : 'lc-dash') + '">' + (has ? '✓' : '—') + '</span> ' + label + '</li>';
      }).join('');
      return (
        '<div>' +
        '<ul class="lc-checklist">' + rows + '</ul>' +
        '</div>'
      );
    }).join('');
  }

  function renderFit() {
    var items = selected.map(function (id) { return byId(id); });

    // Same row-per-field approach as renderDetails: each field is its own
    // grid row across both columns so "Sizes" (and everything else) stays
    // aligned even when optional fields like rise, gusset, or product
    // detail are present for one column but not the other.
    function row(renderField) {
      return items.map(function (p) {
        if (!p) return '<div></div>';
        return '<div>' + renderField(p) + '</div>';
      }).join('');
    }

    var html = '';
    html += row(function () { return '<div class="lc-label-sm">Fit &amp; feel</div>'; });
    html += row(function (p) { return p.waist_rise ? '<div class="lc-fit-rise">' + p.waist_rise + '</div>' : ''; });
    html += row(function (p) {
      var coverageLines = (p.fit_coverage || '').split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
      var coverageHtml = coverageLines.map(function (line) {
        return '<div class="lc-fit-coverage-line">' + line + '</div>';
      }).join('');
      return '<div style="margin-bottom:14px;">' + coverageHtml + '</div>';
    });
    // Optional product-detail blurb (custom.comparison_product_detail),
    // shown as its own labeled block underneath Fit & feel's lines.
    html += row(function (p) { return p.product_detail ? '<div class="lc-label-sm">Product detail</div>' : ''; });
    html += row(function (p) { return p.product_detail ? '<div class="lc-fit-coverage-line" style="margin-bottom:14px;">' + p.product_detail + '</div>' : ''; });
    html += row(function (p) { return p.gusset_material ? '<div class="lc-label-sm">' + p.gusset_material + '</div>' : ''; });
    html += row(function () { return '<div class="lc-label-sm">Sizes</div>'; });
    html += row(function (p) { return '<div class="lc-val">' + (p.sizes || '') + '</div>'; });

    document.getElementById('lc-fit').innerHTML = html;
  }

  function renderEmptyState() {
    document.getElementById('lc-board').innerHTML =
      '<p class="lc-empty">No products found. Check that at least one product has "Comparison: Include in Tool" set to true, and that it\'s within the first 250 products searched.</p>';
  }

  function renderAll() {
    renderBoard();
    renderDetails();
    renderPerformance();
    renderFit();
  }

  if (DATA.length) {
    renderAll();
  } else {
    renderEmptyState();
  }
})();